<template>
  <div class="vFooter">
    <b-card
     bg-variant="danger" text-variant="white" header="聯絡我們" class="text-center"
     >
      <b-card-text>
        <b-row>
          <b-col></b-col>
          <b-col>
            <!-- <a href="https://ocia.ncut.edu.tw/"
              ><img src="@/../public/OCIA5.png"
            /></a> -->
          </b-col>
          <b-col>
            <div style="text-align: left">
            <span> 產學營運處　</span> <a href="mailto:ocic@ncut.edu.tw">ocic@ncut.edu.tw</a> <br />
             <span> 國際產業聯絡中心　04-23924505轉2628 林小姐</span><br />
              <span> 產業技術服務管理中心　04-23924505轉2635 張小姐</span><br />

            </div>
          </b-col>

          <b-col></b-col>
        </b-row>
        <b-row>
          <b-col>
 國立勤益科技大學  © National Chin-Yi University of Technology

地址:41170 臺中市太平區坪林里中山路二段57號|Address:No.57, Sec. 2, Zhongshan Rd., Taiping Dist., Taichung 41170, Taiwan (R.O.C.)

電話:04-23924505 分機 2471，FAX:04-23931260 *建議最佳瀏覽環境:1024x768以上解析度‧建議使用Google Chrome瀏覽

          </b-col>
        </b-row>
      </b-card-text>
    </b-card>
  </div>
</template>

<script>
export default {
  name: "vFooter",
  computed: {},
  methods: {},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
